<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="d-flex justify-content-between">
        <h4>{{ 'pages.transport.detail-page.documents.headline' | translate }}</h4>
      </div>
    </div>
    <div class="row">
      @if (errorMessage()) {
        <p-message [severity]="errorMessage()?.severity" [icon]="errorMessage()?.icon" [closable]="false">
          <div class="documents__error-message__text">
            <span class="bold" [innerHTML]="errorMessage()?.summary"> </span>
            <span [innerHTML]="errorMessage()?.detail"></span>
          </div>
        </p-message>
      }
    </div>

    <div class="row">
      <div class="col-12">
        @if (!isComponentOnError()) {
          <myarvato-document-table
            [documents]="documents()"
            [columns]="documentColumns()"
            (viewDocument)="onViewDocument($event)"
            (downloadDocument)="onDownloadDocument($event)"
            [isLoading]="componentLoading()"
            [pageRowsPerPageOptions]="[5, 10, 20]"
            [pagination]="documents().length > 5"
            [savePageSize]="'transport-details-documents-table'"
          >
            <ng-template #tableBottom>
              @if (showUploadDocumentButton) {
                <div class="d-flex justify-content-between">
                  <p-button
                    icon="pi pi-cloud-upload"
                    (onClick)="openUploadDialog()"
                    [label]="'pages.transport.detail-page.documents.upload-button' | translate"
                    styleClass="mr--8"
                    variant="text"
                  />
                </div>
              }
            </ng-template>
          </myarvato-document-table>
        }
      </div>
    </div>
  </div>
</div>
